/**
 * A conversa do painel, em memória.
 *
 * Nada aqui é gravado no navegador: a conversa morre ao trocar de cliente, ao sair
 * do escopo de cliente e no logout (spec 5.4). O backend também não guarda
 * histórico — `idConversa` só agrupa os jobs.
 */
export type ItemDaConversa =
  | { tipo: 'usuario'; id: string; texto: string }
  | { tipo: 'assistente'; id: string; texto: string; especialistas: readonly string[] }
  | { tipo: 'aviso'; id: string; tom: 'atencao' | 'perigo'; texto: string }

export interface Conversa {
  /** `null` até o servidor criar a conversa, na primeira resposta ao `POST`. */
  idConversa: string | null
  itens: readonly ItemDaConversa[]
  /** Há uma pergunta esperando resposta. */
  pendente: boolean
}

export const CONVERSA_VAZIA: Conversa = { idConversa: null, itens: [], pendente: false }

export type AcaoDaConversa =
  | { tipo: 'enviou'; id: string; texto: string }
  | {
      tipo: 'respondeu'
      id: string
      idConversa: string
      texto: string
      especialistas: readonly string[]
    }
  | {
      tipo: 'falhou'
      id: string
      /** `null` quando o envio falhou antes do 202 e nenhuma conversa foi criada. */
      idConversa: string | null
      tom: 'atencao' | 'perigo'
      texto: string
    }
  | { tipo: 'encerrou' }

export function reduzirConversa(estado: Conversa, acao: AcaoDaConversa): Conversa {
  switch (acao.tipo) {
    case 'enviou':
      return {
        ...estado,
        pendente: true,
        itens: [...estado.itens, { tipo: 'usuario', id: acao.id, texto: acao.texto }],
      }
    case 'respondeu':
      return {
        idConversa: acao.idConversa,
        pendente: false,
        itens: [
          ...estado.itens,
          { tipo: 'assistente', id: acao.id, texto: acao.texto, especialistas: acao.especialistas },
        ],
      }
    case 'falhou':
      return {
        idConversa: acao.idConversa ?? estado.idConversa,
        pendente: false,
        itens: [...estado.itens, { tipo: 'aviso', id: acao.id, tom: acao.tom, texto: acao.texto }],
      }
    case 'encerrou':
      return CONVERSA_VAZIA
  }
}
